<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-vedio"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    fullscreen
    append-to-body
    @close="closeDialog()"
  >
    <video-player
      v-if="showVideo"
      ref="videoPlayer"
      class="video-player-box"
      :options="playerOptions"
      :playsinline="true"
      custom-event-name="customstatechangedeventname"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied"
    />
  </el-dialog>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'ViewVideoDialog',
  components: {
    videoPlayer
  },
  props: {
    dlTitle: {
      type: String,
      default: '查看图片'
    },
    action: {
      type: String,
      default: null,
      required: true
    }
  },
  data () {
    return {
      showVideo: false,
      loading: false, // 页面loading状态
      dialogShow: true, // 模态框dialog显示
      videoUrl: null,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频
        loop: false, // 是否视频一结束就重新开始
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '9:4', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        poster: '', // 封面地址
        sources: [{
          type: 'video/webm', // 类型
          src: null // url地址
        }],
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    };
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    // 播放回调
    onPlayerPlay (player) {
      // console.log('开始播放!', player);
    },
    // 暂停回调
    onPlayerPause (player) {
      // console.log('暂停播放!', player);
    },
    // 视频播完回调
    onPlayerEnded (player) {
      // console.log('视频播完!', player);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting (player) {
      // console.log('DOM元素上的readyState更改导致播放停止', player);
    },
    // 已开始播放回调
    onPlayerPlaying (player) {
      console.log('已开始播放', player);
    },
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata (player) {
      console.log('当前播放位置正在下载数据', player);
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate (player) {
      console.log('播放位置发生变化', player);
    },
    // 媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
    },
    // 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
    },
    // 播放状态改变回调  or listen state event
    playerStateChanged (playerCurrentState) {
      console.log('player current update state', playerCurrentState);
    },
    // player is ready 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied (player) {
      console.log('the player is readied', player);
      // you can use it to do something...
      // player.[methods]
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  mounted () {
    this.playerOptions.sources[0].src = this.action;
    this.showVideo = true;
  }
};
</script>

<style lang="scss">
.theme-beta .o-vedio .el-dialog.is-fullscreen .el-dialog__body{
  max-height: unset;
}
</style>
